let bqjUrl = ""; //这里是一个默认的url，可以没有
let svipUrl =""; //
switch (process.env.NODE_ENV) {
    case 'development':
        bqjUrl = "http://localhost:18898" //这里是本地的请求
        // bqjUrl = "https://fzxhback.bqj.cn" // 测试环境
        svipUrl = "https://tsmars.bqj.cn/"
        break
    case 'test':
        bqjUrl = "https://tsfzxhback.bqj.cn:10443" // 测试环境
        svipUrl = "https://tsmars.bqj.cn:10443/"
        break
    case 'production':
        bqjUrl = "https://fzxhback.bqj.cn" //生产环境
        svipUrl =  "https://svip.bqj.cn/"
        break
    default:
        bqjUrl = "https://previpback.bqj.cn" // 测试环境
        bqjUrl = "http://127.0.0.1:18888"
        break
}

export{
    bqjUrl
};
